const validateEmailSyntax = (email, setError) => {
  if (!email) {
    setError && setError('email is required');
    return false;
  }
  if (!email.toLowerCase().match(/^\S+@\S+\.\S+$/)) {
    setError && setError('email has invalid syntax');
    return false;
  }
  return true;
};

export default validateEmailSyntax;
